export const lnsStatus = {
    1: "Ativo",
    2: "Sem Comunicação",
    3: "Alerta",
    4: "Inativo",
};